import { FeatureToggleClientService } from 'feature-toggle-client';
const blipStoreVisibility = 'blip-store-visibility';
const blipStoreBannerServicePageVisibility = 'blip-store-banner-service-page-visibility';
const blipStoreHomeBotPluginsRecommendation = 'blip-store-home-bot-plugins-recommendation';
const blipStoreIntegrationsPluginsRecommendation = 'blip-store-integrations-plugins-recommendation';
const blipStoreListPluginsHomeBot = 'blip-store-menu-list-plugins-home-bot';
const blipStoreExtensionsHomeBot = 'blip-store-menu-extension-home-bot';
const blipStoreHomePortalPluginsRecommendation = 'blip-store-home-portal-plugins-recommendation';
export class BlipStoreFeatures {
    static async isBlipStoreEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(blipStoreVisibility);
    }
    static async isBlipStoreBannerServicePageEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(blipStoreBannerServicePageVisibility);
    }
    static async isBlipStoreHomeBotPluginsRecommendationServicePageEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(blipStoreHomeBotPluginsRecommendation);
    }
    static async isBlipStoreIntegrationsPluginsRecommendationServicePageEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(blipStoreIntegrationsPluginsRecommendation);
    }
    static async isBlipStoreListPluginsHomeBotServicePageEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(blipStoreListPluginsHomeBot);
    }
    static async isBlipStoreExtensionsHomeBotServicePageEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(blipStoreExtensionsHomeBot);
    }
    static async isBlipStoreHomePortalPluginsRecommendationServicePageEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(blipStoreHomePortalPluginsRecommendation, false);
    }
}
